export default __webpack_public_path__ + "static/750-44f7adf17b670f6e588d99fc11271c80.gif";